module.exports = require('./lib/polyfill')['default'];
